import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/**
 * Sahifani dangasa yuklash (code-splitting): har modul sahifasi alohida chunk.
 *   { path: 'orders', ...page(() => import('./pages/OrdersPage')) }
 */
export function page(load: () => Promise<{ default: ComponentType }>): Pick<RouteObject, 'lazy'> {
  return {
    lazy: async () => ({ Component: (await load()).default }),
  };
}

/** Modul veb-marshrutlari: portal ichidagi nisbiy yo'llar (`orders`, `orders/:id`). */
export interface ModuleRoutes {
  workRoutes: RouteObject[];
  sellerRoutes: RouteObject[];
}
